import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { createAddress, fetchAddress, fetchAddressByCategory } from "../thunks/address-thunk";

const addressSlice = createSlice({
    name: "address",
    initialState: {
        data: [],
        selectedAddress: {},
        primaryAddress: {}
    },
    reducers: {
        setSelectedAddress(state, action) {
            state.selectedAddress = action.payload
        },
        setPrimaryAddress(state, action){
            state.primaryAddress = action.payload;
        }
    },
    extraReducers(builder){
        builder.addCase(fetchAddress.fulfilled, (state, action) => {
            state.data = action.payload;
        })
        builder.addCase(createAddress.fulfilled, (state, action) => {

        })
        builder.addCase(fetchAddressByCategory.fulfilled, (state, action) => {
            state.data = action.payload;
        })
    }
});

const addressSliceName = addressSlice.name;
const addressReducer = addressSlice.reducer;
const useAddressStore = () => useSelector((state) =>  state.address);

export const { setSelectedAddress, setPrimaryAddress} = addressSlice.actions;

export {
    addressSliceName,
    addressReducer,
    useAddressStore
};